<template>
  <Popover class="absolute inset-0">
    <PopoverButton class="absolute inset-0 flex justify-center items-center" @click="show">
      <EllipsisHorizontalIcon class="h-4 w-4 mr-1" />
    </PopoverButton>

    <transition-appear origin="center">
      <PopoverPanel v-if="isOpened" class="absolute top-[5px] right-[5px] w-screen max-w-max" static>
        <OnClickOutside @trigger="close">
          <div class="isolate inline-flex rounded-md shadow-lg">
            <button
              v-if="row.deletedAt"
              type="button"
              class="btn-list-action rounded-l-md"
              @click="emit('enable', row)"
            >
              <EyeIcon class="mr-2 h-3 text-slate-400" />
              Enable user
            </button>

            <button
              v-else
              type="button"
              class="btn-list-action"
              :class="row.deletedAt ? '' : 'rounded-l-md'"
              @click="emit('disable', row)"
            >
              <EyeSlashIcon class="mr-2 h-3 text-slate-400" />
              Disable user
            </button>

            <button
              type="button"
              class="btn-list-action"
              @click="emit('addTime', row)"
            >
              <ClockIcon class="mr-2 h-3 text-slate-400" />
              Add 10 Hours
            </button>

            <button
              type="button"
              class="btn-list-action"
              @click="emit('removeTime', row)"
            >
              <NoSymbolIcon class="mr-2 h-3 text-slate-400" />
              Remove Time
            </button>

            <button
              type="button"
              class="btn-list-action"
              @click="emit('setTime', row)"
            >
              <ClockIcon class="mr-2 h-3 text-slate-400" />
              Set time (min)
            </button>

            <router-link
              :to="`/sessions?search=${row.id}`"
              class="btn-list-action"
            >
              <CpuChipIcon class="mr-2 h-3 text-slate-400" />
              Sessions
            </router-link>

            <router-link
              :to="`/user/${row.id}`"
              class="btn-list-action rounded-r-md"
            >
              <PencilSquareIcon class="mr-2 h-3 text-slate-400" />
              Edit
            </router-link>
          </div>
        </OnClickOutside>
      </PopoverPanel>
    </transition-appear>
  </Popover>
</template>

<script setup>
import { Popover, PopoverButton, PopoverPanel } from '@headlessui/vue';
import TransitionAppear from './TransitionAppear.vue';
import { ref, watch } from 'vue';
import { OnClickOutside } from '@vueuse/components';
import { EllipsisHorizontalIcon, PencilSquareIcon, EyeIcon, EyeSlashIcon, ClockIcon, CpuChipIcon, NoSymbolIcon } from '@heroicons/vue/24/outline';

const props = defineProps({
  row: {
    type: Object,
    default: () => {}
  },
  index: {
    type: Number,
    default: null
  },
  isRowHovered: {
    type: Boolean,
    default: false
  }
});

const emit = defineEmits([ 'enable', 'disable', 'addTime', 'removeTime', 'setTime' ]);

const isOpened = ref(false);

watch(() => props.isRowHovered, val => isOpened.value = val);

function show() {
  isOpened.value = true;
}

function close() {
  isOpened.value = false;
}
</script>
